import { RootState } from "../store";

export const layerVisibilitySelector = (state: RootState) => {
  return state.editor.layerVisibility;
};
